import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "date-input__label" }
const _hoisted_2 = ["for"]

import ErrorMessage from '@/corePagesModule/components/ErrorMessage.vue';
import { i18n } from '@/i18n';
import DateInput from '@/corePagesModule/components/DateInput.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DateInputWithLabel',
  props: {
    modelValue: {},
    label: {},
    isError: { type: Boolean },
    errorMessage: { default: undefined },
    placeholder: { default: '選択してください' },
    disabled: { type: Boolean },
    format: { default: 'yyyy/MM/dd' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;
const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.label !== '')
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: `date-input-${_ctx.label}`,
            class: "date-input__label-text"
          }, _toDisplayString(_ctx.label), 9, _hoisted_2))
        : _createCommentVNode("", true),
      _createVNode(ErrorMessage, {
        "is-error": _ctx.isError,
        "error-message": _ctx.errorMessage
      }, null, 8, ["is-error", "error-message"])
    ]),
    _createVNode(DateInput, {
      "model-value": props.modelValue,
      placeholder: props.placeholder,
      disabled: props.disabled,
      format: props.format,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emits('update:modelValue', $event)))
    }, null, 8, ["model-value", "placeholder", "disabled", "format"])
  ]))
}
}

})